// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__zOFpH","block":"loading_block__xBH0R","top":"loading_top__cCFzS","medium":"loading_medium__ETLA0","bottom":"loading_bottom__PYNDp"};